import axios from "axios";
import React, { useEffect, useRef } from "react";
import { useState } from "react"
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { afterTaxDiscountCalculateTotal, beforeTaxDiscountCalculateTotal } from "../../utils/TaxCalculation";


const CreateSell = () => {

    const navigate = useNavigate();
    const params = useParams();
    const id = params.id;

    const { user } = useSelector(state => state.user);

    const [customerDetails, setCustomerDetails] = useState();


    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get(`/customer/${id}`);
                if (response.data.success) {
                    setCustomerDetails(response.data.customer);
                }
            } catch (error) {
                console.log(error);
            }
        })()
    }, [])



    const [products, setproducts] = useState();
    const [categories, setCategories] = useState()
    const [disableProduct, setDisableProduct] = useState(true);
    const [disableQty, setDisableQty] = useState(true);
    const [disableTax, setDisableTax] = useState(false);


    useEffect(() => {
        (async () => {
            try {

                const response = await axios.get("/category/");
                if (response.data.success) {
                    setCategories(response.data.categories);
                }

            } catch (error) {
                toast.error(error.response.data.message);
            }
        })();

    }, []);


    const [selectedCategory, setselectedCategory] = useState();
    const [isCategorySelected, setIsCategorySelected] = useState(false);
    const changeCategory = async (e) => {
        let value = e.target.value;

        setselectedCategory(value);
        setIsCategorySelected(true);
        // setDisableProduct(false);
    }

    useEffect(() => {

        if (isCategorySelected) {
            (async () => {
                try {

                    const response = await axios.get(`/product/get/${selectedCategory}`);

                    if (response.data.success) {
                        setproducts(response.data.products);
                        // if (response.data.products.length > 0) {
                        //     setDisableProduct(false);
                        // }
                    }

                } catch (error) {
                    toast.error(error.response.data.message);
                    setproducts([]);
                }

            })();
        }


    }, [selectedCategory]);





    const [paymentMethod, setPaymentMethod] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!paymentMethod) {
            toast.error("Payment Method is required");
            return;
        }

        let data = {
            date,
            paymentMethod,
            customer: id,
            category: selectedCategory,
            products: rows
        }

        try {
            const response = await axios.post("/sell/create", data)
            if (response.data.success) {
                toast.success(response.data.message);
                navigate(`/invoice/${response.data.selling._id}`);
            }

        } catch (error) {
            toast.error(error.response.data.message);
        }
    }


    //Table 
    const [rows, setRows] = useState([{ product: '', quantity: "", price: "", sellingGst: "", total: "", availableQty: "", discount: "", }]);

    const handleAddRow = () => {
        setRows([...rows, { product: '', quantity: "", price: "", sellingGst: "", total: "", availableQty: "", discount: "", }]);
    };

    const handleRemoveRow = () => {

        let temp = rows.slice(0, rows.length - 1);
        setRows(temp);
    }



    const [tax, setTax] = useState("");

    //enabling product when categories and tax Calculation-type selected
    useEffect(() => {
        if (selectedCategory && tax) {
            setDisableProduct(false)
        }
    }, [selectedCategory, tax])

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        if (field === "name") {
            products.forEach((product) => {
                if (value === product?.name) {
                    updatedRows[index]["product"] = product?._id;
                    updatedRows[index]["price"] = product?.sellingPrice;
                    updatedRows[index]["sellingGst"] = product?.gst;
                    updatedRows[index]["availableQty"] = product?.stock;
                    updatedRows[index]["discount"] = product?.discount;
                }
            })
        }
        updatedRows[index][field] = value;
        if (tax === "afterTax") {
            updatedRows[index]["total"] = afterTaxDiscountCalculateTotal(updatedRows[index].quantity, updatedRows[index].price, updatedRows[index].sellingGst, updatedRows[index].discount);
        } else if (tax === "beforeTax") {
            updatedRows[index]["total"] = beforeTaxDiscountCalculateTotal(updatedRows[index].quantity, updatedRows[index].price, updatedRows[index].sellingGst, updatedRows[index].discount);
        }

        setRows(updatedRows);
    };

    const [date, setDate] = useState(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate());

    // handle reset category selection
    const handleReset = (e) => {
        setselectedCategory("");
        setRows([{ product: '', quantity: "", price: "", sellingGst: "", total: "", availableQty: "" }])
        setIsCategorySelected(false);
        setDisableProduct(true);
        setDisableTax(false)
    }

    //calculating the grand total
    const [grandTotal, setGrandTotal] = useState();
    useEffect(() => {
        let grandTotal = 0;
        rows.forEach((r) => {
            grandTotal = grandTotal + r["total"];
        })
        setGrandTotal(grandTotal);
    }, [rows]);

    return (
        <>
            <div>
                <h1 className="text-center mt-6 bg-blue-300 rounded-lg mx-4 text-2xl font-semibold text-blue-700">Sell Products</h1>
                <form onSubmit={handleSubmit} >
                    <div className="grid grid-cols-2 gap-5 mx-10 mt-6">
                        <div>
                            <label htmlFor="date" className="font-bold">Date:</label>
                            <input id="date"
                                type="date"
                                name="date"
                                // value={date.toLocaleDateString()}
                                onChange={(e) => setDate(e.target.value)}
                                value={date}
                                className="input input-bordered input-info w-full" />
                        </div>

                        <div>
                            <label htmlFor="paidAmount" className="font-bold">Payment Method:</label>
                            {/* <input id="paymentMethod"
                                type="text"
                                list="suggestions"
                                name="paymentMethod"
                                value={paymentMethod}
                                placeholder="Select Payment Method"
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                className="input input-bordered input-info w-full" required />

                            <datalist id="suggestions">
                                <option value="CASH">CASH</option>
                                <option value="CARD">CARD</option>
                                <option value="UPI">UPI</option>
                                <option value="NEFT">NEFT</option>
                            </datalist> */}

                            <select name="paymentMethod" onChange={(e) => setPaymentMethod(e.target.value)}
                                value={paymentMethod}
                                className="select select-info w-full max-w-xs">
                                <option selected>Select Payment Method</option>
                                <option value="CASH">CASH</option>
                                <option value="CARD">CARD</option>
                                <option value="UPI">UPI</option>
                                <option value="NEFT">NEFT</option>
                            </select>
                        </div>


                        <div>
                            <label htmlFor="customer" className="font-bold">Customer:</label>
                            <input id="customer"
                                type="text"
                                name="customer"
                                value={customerDetails?.name}
                                className="input input-bordered input-info w-full" readOnly />
                        </div>

                        <div>
                            <label htmlFor="category" className="font-bold">Category:</label>
                            <select onChange={changeCategory} name="category" id="category" className="select select-info w-full" required disabled={isCategorySelected}
                            >
                                <option selected>Select Category</option>
                                {categories?.map((category) => {
                                    return (
                                        <>
                                            <option value={category?._id}>{category?.title}</option>
                                        </>
                                    )
                                })}
                            </select>
                        </div>
                    </div>

                    <div className="m-12 mb-0 ">
                        <h1 className="ml-5 text-2xl font-bold bg-blue-300 p-2 m-2">Total Amount Calculation with Discount</h1>
                        <label className="ml-5 pb-8 text-xl mr-2 font-bold" htmlFor="afterTax">After Tax</label>
                        <input type="radio" id="afterTax" name="tax" value="afterTax"
                            onChange={(e) => {
                                setTax(e.target.value);
                                setDisableTax(true)
                            }}
                            disabled={disableTax} className="radio radio-primary " />
                        <label className="ml-5 text-xl mr-2 font-bold" htmlFor="beforeTax">Before Tax</label>
                        <input type="radio" id="beforeTax" name="tax" value="beforeTax"
                            onChange={(e) => {
                                setTax(e.target.value)
                                setDisableTax(true)
                            }}
                            disabled={disableTax} className="radio radio-primary" />
                    </div>


                    {/* Table................................................................. */}
                    <table className=" bg-white border mx-10 my-4">
                        <thead>
                            <tr>
                                {/* <th className="px-4 py-2 border">id</th> */}
                                <th className="px-4 py-2 border">Product</th>
                                <th className="px-4 py-2 border">Quantity</th>
                                <th className="px-4 py-2 border">Price</th>
                                <th className="px-4 py-2 border">Selling GST</th>
                                <th className="px-4 py-2 border">Discount</th>
                                <th className="px-4 py-2 border">Total</th>
                                <th className="px-4 py-2 border"></th>
                                <th className="px-4 py-2 border"></th>
                            </tr>
                        </thead>
                        <tbody >
                            {rows?.map((row, index) => (
                                <tr key={index}>
                                    <td className="px-4  py-2 border">
                                        <input
                                            type="text"
                                            list="suggestion"
                                            className="w-full px-2 py-1 border rounded"
                                            placeholder="Enter product"
                                            value={row?.name}
                                            disabled={disableProduct}
                                            onChange={(e) => {
                                                handleInputChange(index, 'name', e.target.value);
                                                // changeProduct(row?.id)
                                            }}
                                        />

                                        <datalist id="suggestion" >
                                            {products?.map((product) => {
                                                return <>
                                                    <option value={product?.name}>{product?.name}</option>
                                                </>
                                            })}
                                        </datalist>

                                    </td>
                                    {/* <td  className="px-4 py-2 border">
                                    <input id="customer"
                                type="text"
                                name="customer"
                                value={productName}
                                className="input input-bordered input-info w-full" readOnly />
                                    </td> */}

                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-[200px] px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder={`${row.availableQty} InStock`}
                                            value={row?.quantity}
                                            disabled={disableProduct}
                                            min="1"
                                            max={row?.availableQty.toString()}
                                            onChange={(e) => handleInputChange(index, 'quantity', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="Enter Price"
                                            value={row?.price}
                                            disabled="true"
                                        // onChange={(e) => handleInputChange(index, 'price', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="in %"
                                            value={row?.sellingGst}
                                            disabled="true"
                                        // onChange={(e) => handleInputChange(index, 'sellingGst', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="in %"
                                            value={row?.discount}
                                            disabled="true"
                                        // onChange={(e) => handleInputChange(index, 'sellingGst', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="Total Amount"
                                            value={row?.total}
                                            disabled="true"
                                            onClick={(e) => handleInputChange(index, 'total', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border text-center">
                                        {index === rows.length - 1 && (
                                            <button
                                                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-full"
                                                onClick={handleAddRow} disabled={disableProduct}>
                                                +
                                            </button>
                                        )}
                                    </td>
                                    <td className="px-4 py-2 border text-center">
                                        {index === rows.length - 1 && (
                                            <button
                                                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-full"
                                                onClick={handleRemoveRow} disabled={disableProduct}>
                                                -
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>



                    <div className="mx-10">
                        <button type="submit" className="btn btn-success text-white font-bold mr-2">Submit</button>
                        <button onClick={handleReset} type="reset" className="btn btn-error text-white font-bold">Reset</button>
                    </div>
                    <div className="text-2xl text-center">
                        <h1 className="bg-blue-400 mx-5 rounded-md mt-4 font-bold">Grand Total: ₹{(Number(grandTotal)?.toFixed(2))?.toLocaleString("en-IN")}/-</h1>
                    </div>

                </form>






            </div>
        </>
    )
}

export default CreateSell;